<header>
  <input type="checkbox" id="btn_menu" class="btn_menu" name="btncheck">
  <label for="btn_menu">
    <div class="imgbox2">
      <div class="imgtotal2">
        <img class="brandIMG" src="assets/png/BlancoSVG.svg" alt="Grupo Centro">
      </div>
    </div>
    <mat-icon [ngStyle]="{'color':'white'}" aria-hidden="false" aria-label="Example view_list icon">view_list</mat-icon>
  </label>
  <nav class="menu">
    <div class="imgbox corazon">
      <div class="imgtotal">
        <img class="brandIMG" src="assets/png/BlancoSVG.svg" alt="Grupo Centro">
      </div>

    </div>
    <div class="txtmenu">

      <ul>
        <li class="zoom weightnew" id="inicio" routerLink="/"><a>Inicio</a></li>
        <li class="zoom " id="noticias" routerLink="/noticias"><a>Noticias</a></li>
        <li class="zoom weightnew" id="nosotros" routerLink="/nosotros"><a>Nosotros</a></li>
        <li class="zoom weightnew" id="envivo" routerLink="/envivo"><a>En vivo</a></li>

        <li class="logcom ">
          <button mat-icon-button class="fb" target="_blank" href="https://www.facebook.com/grupocentro05">
            <fa-icon style="color: white; " [icon]="faFacebook"></fa-icon>

          </button>
          <button mat-icon-button class="fb" target="_blank" href="https://www.facebook.com/grupocentro05">
            <fa-icon style="color: white; " [icon]="faInstagram"></fa-icon>
          </button>
          <button mat-icon-button class="fb" target="_blank" href="https://www.facebook.com/grupocentro05">
            <fa-icon style="color: white; " [icon]="faTwiter"></fa-icon>
          </button>
          <button mat-icon-button class="fb" target="_blank" href="https://www.facebook.com/grupocentro05">
            <fa-icon style="color: white; " [icon]="faYoutube"></fa-icon>
          </button>
        </li>
        <!-- DISEÑO PARA MENU MOBILE -->
        <li class="logcom2">
          <button mat-icon-button class="fb" target="_blank" href="https://www.facebook.com/grupocentro05">
            <fa-icon style="color: white; font-size: 15px;" [icon]="faFacebook"></fa-icon>
          </button>
          <button mat-icon-button class="fb" target="_blank" href="https://www.facebook.com/grupocentro05">
            <fa-icon style="color: white; " [icon]="faInstagram"></fa-icon>
          </button>
          <button mat-icon-button class="fb" target="_blank" href="https://www.facebook.com/grupocentro05">
            <fa-icon style="color: white; " [icon]="faTwiter"></fa-icon>
          </button>
          <button mat-icon-button class="fb" target="_blank" href="https://www.facebook.com/grupocentro05">
            <fa-icon style="color: white; " [icon]="faYoutube"></fa-icon>
          </button>
        </li>
        <!-- FIN DISEÑO MOBILE -->

      </ul>
    </div>

  </nav>
</header>

<div class="audiocontent">
  <audio id="audioaux" preload="none" controls src="">
    <p>Your browser does not support HTML5 audio. Here is a <a href="https://radio.yoemito.net:8000/stream">link</a>
      instead.
    </p>
  </audio>

</div>
<router-outlet></router-outlet>
